<template>
    <child />
</template>

<script setup>
import Child from '~/base/components/Child'
</script>
